import { formatPercent } from "@appretio/ui-kit";
import type {
  ValueFormatterParams,
  ValueGetterParams
} from "ag-grid-enterprise";
import { ForecastMetaDataType } from "../../../hooks/useFetchForecastMetaData";

/**
 * Factory returning a ValueGetterFunc for SHARE mode.
 * Computes data[colId] / data["TTL"] for metrics with "sum" temporal aggregation.
 * Non-sum metrics return undefined (blank cell).
 */
export function createShareValueGetter(
  metaData: ForecastMetaDataType
): (params: ValueGetterParams) => unknown {
  return (params: ValueGetterParams) => {
    const colId = params.column.getColId();
    const value = params.data[colId];
    const { metric_name } = params.data;

    if (value === null || value === undefined) return null;

    const aggType = metaData.metricTemporalAgg[metric_name];
    if (aggType !== "sum") return undefined;

    const total = params.data["TTL"];
    if (!total || total === 0) return null;

    return value / total;
  };
}

/**
 * Formats share values as percentages (e.g. 0.25 → "25.00%").
 */
export function shareValueFormatter(params: ValueFormatterParams): string {
  if (params.value === null || params.value === undefined) return "";
  return formatPercent(Number(params.value));
}
